import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';
import { SectorEquipmentType } from '@models/enums';
import {
  EditableComponentProps,
  InformationProps,
  ProcessEnvMap as KeyString,
  SectorEquipment as SectorEquipmentInterface,
  SectorEquipmentType as SectorEquipmentTypeInterface,
} from '@models/interfaces';
import { CustomTable, Panel } from '@shared/components';
import { getPermittingSectorEquipmentsColumns } from './get-sector-equipment-columns';

interface SectorEquipmentProps
  extends EditableComponentProps,
    InformationProps {
  type: SectorEquipmentType;
}

export const PermittingSectorEquipment: FC<SectorEquipmentProps> = ({
  className,
  isEditing = false,
  type,
  data,
}: PropsWithChildren<SectorEquipmentProps>) => (
  <Panel
    header={`Sector Equipment - ${type.toUpperCase()}`}
    className={classNames('prov-sector-equipment', className)}
    collapsible
  >
    <CustomTable
      columns={getPermittingSectorEquipmentsColumns(data?.[type], type)}
      dataSource={
        data?.[type].length
          ? Array.from({ length: 5 }, (_: unknown, index: number) => ({
              ...data?.[type].reduce(
                (
                  acc: {
                    position: number;
                  },
                  dataItem: SectorEquipmentTypeInterface,
                ) => ({
                  ...acc,
                  [dataItem.equipmentType]: dataItem?.equipments?.find(
                    (e: SectorEquipmentInterface) => e?.position === index + 1,
                  )?.equipment,
                  position: index + 1,
                }),
                {},
              ),
            }))
          : []
      }
      hoverable={!isEditing}
      pagination={false}
      rowKey={(record: KeyString & { position: number }): string => {
        const [key] = Object.keys(record);

        return `${type}-${key}-${record[key]}-${record.position}`;
      }}
    />
  </Panel>
);
